module.exports = __webpack_public_path__ + "img/header.782f74c6.png";